var _circle, _path, _path2, _path3, _path4, _path5, _circle2, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTopupCancel(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 120,
    viewBox: "0 0 120 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 60,
    cy: 60,
    r: 60,
    fill: "#FEF3F2"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.6934 35.3259C27.6934 31.1103 31.1108 27.6929 35.3264 27.6929H78.5804C82.796 27.6929 86.2135 31.1103 86.2135 35.3259V71.2649C86.2135 75.4805 82.796 78.898 78.5804 78.898H35.3264C31.1108 78.898 27.6934 75.4805 27.6934 71.2649V35.3259Z",
    fill: "#FDA29B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M35.9619 36.9164C35.9619 33.7547 38.525 31.1917 41.6867 31.1917H86.2129C89.3746 31.1917 91.9377 33.7547 91.9377 36.9164V79.5343C91.9377 82.6961 89.3746 85.2591 86.2129 85.2591H41.6867C38.525 85.2591 35.9619 82.6961 35.9619 79.5343V36.9164Z",
    fill: "#F04438"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M27.6934 43.595C27.6934 39.3794 31.1108 35.9619 35.3264 35.9619H88.7578C92.9734 35.9619 96.3909 39.3794 96.3909 43.595V82.7144C96.3909 86.93 92.9734 90.3475 88.7578 90.3475H35.3264C31.1108 90.3475 27.6934 86.93 27.6934 82.7144V43.595Z",
    fill: "#FDA29B"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M72.5381 56.6348C72.5381 55.5809 73.3924 54.7266 74.4464 54.7266H95.1192C97.227 54.7266 98.9357 56.4353 98.9357 58.5431V65.5401C98.9357 67.6479 97.227 69.3566 95.1192 69.3566H74.4464C73.3924 69.3566 72.5381 68.5022 72.5381 67.4483V56.6348Z",
    fill: "#F04438"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M83.9859 61.8799C83.9859 63.8999 82.3484 65.5374 80.3284 65.5374C78.3084 65.5374 76.6709 63.8999 76.6709 61.8799C76.6709 59.8599 78.3084 58.2224 80.3284 58.2224C82.3484 58.2224 83.9859 59.8599 83.9859 61.8799Z",
    fill: "#FCFCFD"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 37,
    cy: 81,
    r: 14,
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M41.5 76.5L32.5 85.5M32.5 76.5L41.5 85.5M52 81C52 89.2843 45.2843 96 37 96C28.7157 96 22 89.2843 22 81C22 72.7157 28.7157 66 37 66C45.2843 66 52 72.7157 52 81Z",
    stroke: "#B42318",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTopupCancel);
export default __webpack_public_path__ + "static/media/topup-cancel.79587736a916ad72cf3e5b0964a875ad.svg";
export { ForwardRef as ReactComponent };